import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { authClient } from '../../../lib/auth-client';

const OAuthCallback = () => {
    const navigate = useNavigate();
    const { data: session, isPending } = authClient.useSession();

    useEffect(() => {
        if (isPending) return;

        if (session?.user) {
            navigate('/campaign');
        } else {
            navigate('/login');
        }
    }, [session, isPending, navigate]);

    return (
        <div className="flex h-screen items-center justify-center">
            <div className="text-center">
                <Loader2 className="mx-auto size-8 animate-spin text-primary" />
                <p className="mt-3 text-sm text-muted-foreground">Processando autenticação...</p>
            </div>
        </div>
    );
};

export default OAuthCallback;
